"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routeNameByUserType = void 0;
const UserType_1 = require("../context/FormData/UserType");
const router_1 = require("../router");
function routeNameByUserType(userType) {
    switch (userType) {
        case UserType_1.UserType.Academic:
            return router_1.Route.Academic;
        case UserType_1.UserType.Student:
            return router_1.Route.Student;
        case UserType_1.UserType.Enthusiast:
            return router_1.Route.Enthusiast;
        case UserType_1.UserType.HealthcareProvider:
            return router_1.Route.HealthcareProvider;
        case UserType_1.UserType.AlternativePractitioner:
            return router_1.Route.AlternativePractitioner;
    }
}
exports.routeNameByUserType = routeNameByUserType;
